module.exports = __webpack_public_path__ + "img/194.c0c0bbe8.jpg";